import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import FounderImg from "../aseets/img/founderImg.png";
import "../Css/Founder.css";
import axios from "axios";

const FounderSection = () => {

  const [receivedData, setReceivedData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/list/Founder`);
                setReceivedData(response.data[0]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);
  return (
    <React.Fragment>
      <div className="founderMainDiv">
        <Container>
          <Row>
            <Col lg={5} md={5}>
              <img src={`${process.env.REACT_APP_API_URL}/${receivedData.FounderImage}`} alt="img" />
            </Col>
            <Col lg={7} md={7}>
              <div className="founderTitle">{receivedData.keyWord}</div>
              <div className="missonTite">
                
                {receivedData.Title}

              </div>
              <div className="aboutPera founderDescription">
              {receivedData.Description}
              </div>
             
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FounderSection;
